import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import Button from "components/button/Button";
import useAuth from "hooks/auth/useAuth";
import useDarkMode from "hooks/useDarkMode";

const firstList = [
  {
    title: "Գլխավոր",
    value: "/",
  },
  { title: "Կանխատեսողներ", value: "/predictors" },
  { title: "Կանխատեսումներ", value: "/predictions" },
  { title: "Խոստումներ", value: "/promises" },
  { title: "Ընդհանրական", value: "/surveys" },
];

const secondList = [
  { title: "Կապ", value: "/contact" },
  { title: "Մեր մասին", value: "/about-us" },
  { title: "Հարցեր և պատասխաններ", value: "/questions" },
  { title: "Օգտագործման պայմաններ", value: "/terms-of-use" },
  { title: "Գաղտնիության Քաղաքականություն", value: "/privacy-policy" },
];

const Footer = ({ currentUser, isLoading, signOut }) => {
  const router = useRouter();
  const { theme, mounted } = useDarkMode();
  const isDark = mounted && theme === "dark";

  return (
    <footer
      style={{ fontFamily: "Noto Sans Armenian" }}
      className="bg-white dark:bg-[#030014] border-t border-slate-100 dark:border-white/5 px-4 sm:px-6 md:px-12 xl:px-24 py-8 md:py-12 text-slate-600 dark:text-slate-400 w-full overflow-hidden"
    >
      <div className="max-w-7xl mx-auto flex flex-col xl:flex-row justify-between items-start gap-8">
        <div className="flex flex-col gap-4 max-w-sm">
          {!router.pathname.includes("auth") && (
            <Link href="/" className="flex items-center cursor-pointer">
              <img
                src={isDark ? "/logo-dark.svg" : "/logo.svg"}
                alt="Prognos"
                className="h-8 w-auto object-contain"
              />
            </Link>
          )}
          <p className="text-xs leading-relaxed text-slate-500 dark:text-slate-400">
            Սույն կայքում տեղ գտած հրապարակումների հեղինակային իրավունքը պատկանում է բացառապես prognos.am-ին:
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          {firstList.map((page, index) => (
            <Link
              key={page.value || index}
              className="text-sm font-medium text-slate-700 dark:text-slate-300 hover:text-[#0033FF] transition-colors"
              href={page.value}
            >
              {page.title}
            </Link>
          ))}
        </div>

        <div className="flex flex-col gap-2.5">
          {secondList.map((page, index) => (
            <Link
              key={page.value || index}
              href={page.value}
              className="text-sm font-medium text-slate-700 dark:text-slate-300 hover:text-[#0033FF] transition-colors"
            >
              {page.title}
            </Link>
          ))}
        </div>

        {!router.pathname.includes("auth") && !isLoading && !currentUser && (
          <div className="flex items-center gap-3 mt-4 xl:mt-0">
            <button
              onClick={() =>
                router.push(
                  { pathname: "/auth", query: { mode: "registration" } },
                  undefined,
                  { shallow: true },
                )
              }
              className="text-[#0033FF] font-bold text-sm px-4 py-2 hover:opacity-80 transition-all cursor-pointer"
            >
              Գրանցվել
            </button>
            <Button
              onClick={() =>
                router.push(
                  { pathname: "/auth", query: { mode: "login" } },
                  undefined,
                  { shallow: true },
                )
              }
              className="!bg-[#0033FF] hover:!bg-[#0026cc] !text-white !rounded-full !px-6 !py-2 !text-sm !font-bold"
            >
              Մուտք
            </Button>
          </div>
        )}
        {!isLoading && currentUser && (
          <div className="mt-4 xl:mt-0">
            <Button onClick={signOut} variant="danger" className="!py-2 !px-5 !text-xs">
              Դուրս գալ
            </Button>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
